import Vue from 'vue'

export async function fetchBirthdays({
  commit
}) {
  try {
    const {
      data
    } = await Vue.axios({
      url: '/frontend/birthdays'
    })
    commit('setBirthdays', data)
  } catch (error) {
    commit('birthdaysError', error.message)
  } finally {
    // console.log('la peticion de cumpleaños de los usuarios ha finalizado')
  }
}